var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.155,
    height: 24.453,
    viewBox: "0 0 26.155 24.453",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Servings",
    transform: "translate(0.199 0.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2762",
    "data-name": "Group 2762",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1759",
    "data-name": "Path 1759",
    d: "M301.892,506.977a1.046,1.046,0,0,1-1.047-1.046,6.755,6.755,0,0,0-4.275-6.3,11.36,11.36,0,0,1-13.022,0,6.757,6.757,0,0,0-4.273,6.3,1.047,1.047,0,0,1-1.047,1.046h0a1.046,1.046,0,0,1-1.047-1.047,8.843,8.843,0,0,1,6.228-8.474,1.048,1.048,0,0,1,.955.172,9.269,9.269,0,0,0,11.388,0,1.051,1.051,0,0,1,.955-.173,8.843,8.843,0,0,1,6.23,8.474A1.047,1.047,0,0,1,301.892,506.977Z",
    transform: "translate(-277.182 -482.924)",
    fill: "#121e59",
    stroke: "#121e59",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1760",
    "data-name": "Path 1760",
    d: "M293.758,487.932a7.371,7.371,0,1,1,7.371-7.371A7.379,7.379,0,0,1,293.758,487.932Zm0-12.649a5.278,5.278,0,1,0,5.278,5.278A5.284,5.284,0,0,0,293.758,475.283Z",
    transform: "translate(-280.881 -473.19)",
    fill: "#121e59",
    stroke: "#121e59",
    strokeWidth: 0.4
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServings);
export default __webpack_public_path__ + "static/media/servings.8037b7ef560a8c4f04e3861731cff512.svg";
export { ForwardRef as ReactComponent };